import {createSvgIcon} from '../create-svg-icon';

export const GMobiledataIcon = createSvgIcon(
  <path d="M12 11v2h2v2H9V9h7c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4z" />
, 'GMobiledataOutlined');
